const hebrewPattern = /(?:(?:[\u0590-\u05FF]{2,})|(?<=\S)[\u0590-\u05FF]{2,})/;
const isHebrew = (text: string) => hebrewPattern.test(text);

export const getTextAlignmentValue = (text: string) => isHebrew(text) ? "right" : "left"
export const getTextAlignmentClassName = (text: string) => isHebrew(text) ? "text-right" : "text-left"
export const getTextDirection = (text: string) => isHebrew(text) ? "rtl" : "ltr"